var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-md font-semibold inline-block py-1 px-2 uppercase rounded text-blue-600 bg-blue-200 uppercase last:mr-0 mr-1 count-box"},[_vm._v(" 制限時間: "),(!_vm.isEnd)?_c('span',[_vm._v(_vm._s(_vm.timerStr))]):_c('span',{staticStyle:{"color":"red"}},[_vm._v("時間切れ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }